import { render, staticRenderFns } from "./SmsEmptyMessage.vue?vue&type=template&id=1436dcc0&scoped=true&"
import script from "./SmsEmptyMessage.vue?vue&type=script&lang=js&"
export * from "./SmsEmptyMessage.vue?vue&type=script&lang=js&"
import style0 from "./scoped.scss?vue&type=style&index=0&id=1436dcc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1436dcc0",
  null
  
)

export default component.exports